<template>
    <div class="user-index">
        <!-- Dialog tạo / cập nhật tài khoản người dùng -->
        <create-dialog ref="createDialog" v-model="dialog"></create-dialog>

        <!-- Thẻ chính bao ngoài theo phong cách bo tròn chuẩn hệ thống -->
        <v-card class="rounded-xl elevation-3" flat>
            <!-- Tiêu đề và nhóm nút hành động chính -->
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Danh sách người dùng
                <v-spacer></v-spacer>

                <!-- Nút tải lại dữ liệu -->
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block
                        style="width: 40px !important; height: 40px; padding: 0px;" title="Tải lại">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>

                <!-- Nút xuất dữ liệu ra file Excel -->
                <vue-excel-xlsx
                    :data="excelData"
                    :columns="excelColumns"
                    :file-name="'DU_LIEU_USER'"
                    :file-type="'xlsx'"
                    :sheet-name="'Danh_sach_user'"
                >
                    <v-btn outlined color="teal lighten-3" class="rounded-lg ml-2"
                        style="width: 40px !important; height: 40px; padding: 0px;" title="Xuất Excel">
                        <v-icon color="teal darken-4">mdi-microsoft-excel</v-icon>
                    </v-btn>
                </vue-excel-xlsx>

                <v-divider vertical class="mx-4"></v-divider>

                <!-- Nút tạo tài khoản mới -->
                <v-btn @click="openDialog" dark color="teal darken-4"
                    class="rounded-pill elevation-3 ml-4 font-weight-bold px-6">
                    <v-icon left>mdi-plus</v-icon> TẠO NGƯỜI DÙNG
                </v-btn>
            </v-card-title>

            <!-- Thanh Tabs phân loại tài khoản chuẩn -->
            <div class="px-6 pb-0">
                <v-tabs v-model="tab" color="teal darken-4" class="custom-tabs" height="40">
                    <v-tab class="font-weight-bold">Tài khoản nhân viên ({{ items.length }})</v-tab>
                    <v-tab class="font-weight-bold">Tài khoản Admin ({{ admins.length }})</v-tab>
                    <v-tab class="font-weight-bold">Tài khoản API & test ({{ services.length }})</v-tab>
                    <v-tab class="font-weight-bold">Lịch sử thao tác ({{ logs.length }})</v-tab>
                </v-tabs>
            </div>

            <!-- Thanh bộ lọc tiêu chuẩn chuẩn hệ thống (áp dụng cho các tab tài khoản) -->
            <v-sheet class="grey lighten-4 py-6" v-if="tab !== 3" style="border-top: 1px solid #eee;">
                <div class="d-flex flex-wrap align-center px-6" style="gap: 12px;">
                    <!-- Lọc theo Mã Nhân Sự -->
                    <div style="width: 150px;">
                        <v-text-field label="Mã NS" placeholder="NS00..." dense v-model="filters.employeeCode"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>

                    <!-- Lọc theo Tên Nhân Sự -->
                    <div style="width: 220px;">
                        <v-text-field label="Tên nhân sự" placeholder="Nhập tên..." dense v-model="filters.employeeName"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>

                    <!-- Lọc theo Mã Người Dùng -->
                    <div style="width: 150px;">
                        <v-text-field label="Mã người dùng" placeholder="Mã..." dense v-model="filters.code"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>

                    <!-- Lọc theo Tên Đăng Nhập -->
                    <div style="width: 180px;">
                        <v-text-field label="Tên đăng nhập" placeholder="Username..." dense v-model="filters.userName"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>

                    <!-- Lọc theo Phòng ban -->
                    <div style="width: 240px;">
                        <v-autocomplete label="Phòng ban" clearable outlined :items="departments" item-text="name" item-value="code"
                            v-model="filters.departmentCode" dense hide-details color="teal darken-4"
                            class="white rounded-lg" placeholder="Chọn phòng ban"></v-autocomplete>
                    </div>

                    <!-- Nút xóa bộ lọc -->
                    <div>
                        <v-btn @click="resetFilters" text color="grey darken-2" class="rounded-lg font-weight-bold" height="40">
                            <v-icon left small>mdi-filter-remove-outline</v-icon> Xóa lọc
                        </v-btn>
                    </div>
                </div>
            </v-sheet>

            <!-- Thanh thống kê chip màu chuẩn hệ thống -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5"
                style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng tài khoản: <b class="ml-1">{{ items.length + admins.length + services.length }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-account-outline</v-icon>
                    Nhân viên: <b class="ml-1">{{ items.length }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-account-hard-hat</v-icon>
                    Admin: <b class="ml-1">{{ admins.length }}</b>
                </v-chip>
                <v-chip color="purple lighten-4" text-color="purple darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-account-convert</v-icon>
                    API & test: <b class="ml-1">{{ services.length }}</b>
                </v-chip>
            </v-sheet>

            <!-- Nội dung danh sách theo từng Tab -->
            <v-tabs-items v-model="tab">
                <!-- TAB 1: TÀI KHOẢN NHÂN VIÊN -->
                <v-tab-item eager>
                    <v-data-table
                        class="my-custom-table"
                        height="calc(100vh - 350px)"
                        fixed-header
                        :mobile-breakpoint="0"
                        :headers="headers"
                        :items="items"
                        :loading="isLoading"
                        loading-text="Đang tải dữ liệu..."
                        :footer-props="{
                            itemsPerPageOptions: [15, 50, 100, 200, 10000],
                            itemsPerPageText: 'Số dòng mỗi trang'
                        }"
                    >
                        <!-- Cột thao tác -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex align-center">
                                <v-btn x-small depressed rounded class="mx-1 my-1 teal--text text--darken-4 font-weight-bold"
                                    color="teal lighten-5" @click="editItem(item)">
                                    <v-icon left small>mdi-pencil</v-icon> Sửa
                                </v-btn>
                                <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold"
                                    color="grey lighten-4" @click="deleteItem(item)">
                                    <v-icon left small>mdi-delete</v-icon> Xóa
                                </v-btn>
                            </div>
                        </template>

                        <!-- Cột tên đăng nhập -->
                        <template v-slot:[`item.userName`]="{ item }">
                            <span class="font-weight-bold">{{ item.userName }}</span>
                        </template>

                        <!-- Cột phân quyền -->
                        <template v-slot:[`item.userRoles`]="{ item }">
                            <div class="d-flex flex-wrap" style="gap: 4px;">
                                <v-chip v-for="role in item.userRoles" :key="role.roleCode" color="teal lighten-5"
                                    text-color="teal darken-4" small class="caption font-weight-bold" label>
                                    <v-icon left x-small>mdi-shield-check</v-icon>
                                    {{ role.roleName }}
                                </v-chip>
                            </div>
                        </template>

                        <!-- Cột trạng thái hoạt động -->
                        <template v-slot:[`item.isActive`]="{ item }">
                            <v-chip small :color="item.isActive ? 'green lighten-4' : 'red lighten-4'"
                                :text-color="item.isActive ? 'green darken-4' : 'red darken-4'" class="font-weight-medium">
                                <v-icon left x-small>{{ item.isActive ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                {{ item.isActive ? 'Hoạt động' : 'Khóa' }}
                            </v-chip>
                        </template>

                        <!-- Cột phòng ban -->
                        <template v-slot:[`item.departmentName`]="{ item }">
                            <v-chip v-if="item.departmentName" class="caption font-weight-bold" color="teal darken-4" label text-color="white" small>
                                <v-icon left small>mdi-store</v-icon>
                                {{ item.departmentName }}
                            </v-chip>
                        </template>

                        <!-- Cột thiết bị đã đăng nhập -->
                        <template v-slot:[`item.usedDevice`]="{ item }">
                            <v-tooltip bottom eager v-if="!!item.usedDevice">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip small outlined :color="item.usedDevice.length > 16 ? 'grey darken-3' : 'green darken-2'"
                                        v-bind="attrs" v-on="on" class="font-weight-medium" @click="clearDevice(item)">
                                        <v-icon left x-small>{{ item.usedDevice.length > 16 ? 'mdi-apple' : 'mdi-android' }}</v-icon>
                                        Reset
                                    </v-chip>
                                </template>
                                <span>{{ item.usedDevice }} (Nhấn để reset thiết bị)</span>
                            </v-tooltip>
                            <span v-else class="grey--text caption">--</span>
                        </template>
                    </v-data-table>
                </v-tab-item>

                <!-- TAB 2: TÀI KHOẢN ADMIN -->
                <v-tab-item eager>
                    <v-data-table
                        class="my-custom-table"
                        height="calc(100vh - 350px)"
                        fixed-header
                        :mobile-breakpoint="0"
                        :headers="headers"
                        :items="admins"
                        :loading="isLoading"
                        loading-text="Đang tải dữ liệu..."
                        :footer-props="{
                            itemsPerPageOptions: [15, 50, 100, 200, 10000],
                            itemsPerPageText: 'Số dòng mỗi trang'
                        }"
                    >
                        <!-- Cột thao tác -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex align-center">
                                <v-btn x-small depressed rounded class="mx-1 my-1 teal--text text--darken-4 font-weight-bold"
                                    color="teal lighten-5" @click="editItem(item)">
                                    <v-icon left small>mdi-pencil</v-icon> Sửa
                                </v-btn>
                                <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold"
                                    color="grey lighten-4" @click="deleteItem(item)">
                                    <v-icon left small>mdi-delete</v-icon> Xóa
                                </v-btn>
                            </div>
                        </template>

                        <!-- Cột tên đăng nhập -->
                        <template v-slot:[`item.userName`]="{ item }">
                            <span class="font-weight-bold">{{ item.userName }}</span>
                        </template>

                        <!-- Cột phân quyền -->
                        <template v-slot:[`item.userRoles`]="{ item }">
                            <div class="d-flex flex-wrap" style="gap: 4px;">
                                <v-chip v-for="role in item.userRoles" :key="role.roleCode" color="teal lighten-5"
                                    text-color="teal darken-4" small class="caption font-weight-bold" label>
                                    <v-icon left x-small>mdi-shield-check</v-icon>
                                    {{ role.roleName }}
                                </v-chip>
                            </div>
                        </template>

                        <!-- Cột trạng thái hoạt động -->
                        <template v-slot:[`item.isActive`]="{ item }">
                            <v-chip small :color="item.isActive ? 'green lighten-4' : 'red lighten-4'"
                                :text-color="item.isActive ? 'green darken-4' : 'red darken-4'" class="font-weight-medium">
                                <v-icon left x-small>{{ item.isActive ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                {{ item.isActive ? 'Hoạt động' : 'Khóa' }}
                            </v-chip>
                        </template>

                        <!-- Cột phòng ban -->
                        <template v-slot:[`item.departmentName`]="{ item }">
                            <v-chip v-if="item.departmentName" class="caption font-weight-bold" color="teal darken-4" label text-color="white" small>
                                <v-icon left small>mdi-store</v-icon>
                                {{ item.departmentName }}
                            </v-chip>
                        </template>

                        <!-- Cột thiết bị đã đăng nhập -->
                        <template v-slot:[`item.usedDevice`]="{ item }">
                            <v-tooltip bottom eager v-if="!!item.usedDevice">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip small outlined :color="item.usedDevice.length > 16 ? 'grey darken-3' : 'green darken-2'"
                                        v-bind="attrs" v-on="on" class="font-weight-medium" @click="clearDevice(item)">
                                        <v-icon left x-small>{{ item.usedDevice.length > 16 ? 'mdi-apple' : 'mdi-android' }}</v-icon>
                                        Reset
                                    </v-chip>
                                </template>
                                <span>{{ item.usedDevice }} (Nhấn để reset thiết bị)</span>
                            </v-tooltip>
                            <span v-else class="grey--text caption">--</span>
                        </template>
                    </v-data-table>
                </v-tab-item>

                <!-- TAB 3: TÀI KHOẢN API & TEST -->
                <v-tab-item eager>
                    <v-data-table
                        class="my-custom-table"
                        height="calc(100vh - 350px)"
                        fixed-header
                        :mobile-breakpoint="0"
                        :headers="headers"
                        :items="services"
                        :loading="isLoading"
                        loading-text="Đang tải dữ liệu..."
                        :footer-props="{
                            itemsPerPageOptions: [15, 50, 100, 200, 10000],
                            itemsPerPageText: 'Số dòng mỗi trang'
                        }"
                    >
                        <!-- Cột thao tác -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex align-center">
                                <v-btn x-small depressed rounded class="mx-1 my-1 teal--text text--darken-4 font-weight-bold"
                                    color="teal lighten-5" @click="editItem(item)">
                                    <v-icon left small>mdi-pencil</v-icon> Sửa
                                </v-btn>
                                <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold"
                                    color="grey lighten-4" @click="deleteItem(item)">
                                    <v-icon left small>mdi-delete</v-icon> Xóa
                                </v-btn>
                            </div>
                        </template>

                        <!-- Cột tên đăng nhập -->
                        <template v-slot:[`item.userName`]="{ item }">
                            <span class="font-weight-bold">{{ item.userName }}</span>
                        </template>

                        <!-- Cột phân quyền -->
                        <template v-slot:[`item.userRoles`]="{ item }">
                            <div class="d-flex flex-wrap" style="gap: 4px;">
                                <v-chip v-for="role in item.userRoles" :key="role.roleCode" color="teal lighten-5"
                                    text-color="teal darken-4" small class="caption font-weight-bold" label>
                                    <v-icon left x-small>mdi-shield-check</v-icon>
                                    {{ role.roleName }}
                                </v-chip>
                            </div>
                        </template>

                        <!-- Cột trạng thái hoạt động -->
                        <template v-slot:[`item.isActive`]="{ item }">
                            <v-chip small :color="item.isActive ? 'green lighten-4' : 'red lighten-4'"
                                :text-color="item.isActive ? 'green darken-4' : 'red darken-4'" class="font-weight-medium">
                                <v-icon left x-small>{{ item.isActive ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
                                {{ item.isActive ? 'Hoạt động' : 'Khóa' }}
                            </v-chip>
                        </template>

                        <!-- Cột phòng ban -->
                        <template v-slot:[`item.departmentName`]="{ item }">
                            <v-chip v-if="item.departmentName" class="caption font-weight-bold" color="teal darken-4" label text-color="white" small>
                                <v-icon left small>mdi-store</v-icon>
                                {{ item.departmentName }}
                            </v-chip>
                        </template>

                        <!-- Cột thiết bị đã đăng nhập -->
                        <template v-slot:[`item.usedDevice`]="{ item }">
                            <v-tooltip bottom eager v-if="!!item.usedDevice">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-chip small outlined :color="item.usedDevice.length > 16 ? 'grey darken-3' : 'green darken-2'"
                                        v-bind="attrs" v-on="on" class="font-weight-medium" @click="clearDevice(item)">
                                        <v-icon left x-small>{{ item.usedDevice.length > 16 ? 'mdi-apple' : 'mdi-android' }}</v-icon>
                                        Reset
                                    </v-chip>
                                </template>
                                <span>{{ item.usedDevice }} (Nhấn để reset thiết bị)</span>
                            </v-tooltip>
                            <span v-else class="grey--text caption">--</span>
                        </template>
                    </v-data-table>
                </v-tab-item>

                <!-- TAB 4: LỊCH SỬ THAO TÁC -->
                <v-tab-item eager>
                    <v-data-table
                        class="my-custom-table"
                        height="calc(100vh - 350px)"
                        fixed-header
                        :mobile-breakpoint="0"
                        :headers="headerLogs"
                        :items="logs"
                        :loading="isLoadingLogs"
                        loading-text="Đang tải dữ liệu..."
                        :footer-props="{
                            itemsPerPageOptions: [15, 50, 100],
                            itemsPerPageText: 'Số dòng mỗi trang'
                        }"
                    >
                        <!-- Hiển thị loại hành động với chip màu tương ứng -->
                        <template v-slot:[`item.action`]="{ item }">
                            <v-chip small label :color="getActionColor(item.action)" class="font-weight-bold">
                                {{ item.action }}
                            </v-chip>
                        </template>

                        <!-- Hiển thị thời gian cập nhật -->
                        <template v-slot:[`item.updatedAt`]="{ item }">
                            {{ formatDate(item.updatedAt, true) }}
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>

            <!-- Hộp thoại xác nhận xóa người dùng -->
            <v-dialog v-model="dialogDelete" max-width="450px" persistent>
                <v-card class="rounded-xl">
                    <v-card-title class="text-subtitle-1 font-weight-bold px-6 py-4 d-flex align-center">
                        <v-icon left color="error">mdi-alert-circle-outline</v-icon>
                        Xác nhận xóa người dùng
                        <v-spacer></v-spacer>
                        <v-btn icon small @click="dialogDelete = false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="px-6 py-4 pt-4">
                        Bạn có chắc chắn muốn xóa tài khoản
                        <strong v-if="targetItem" class="red--text text--darken-2">"{{ targetItem.userName }} ({{ targetItem.employeeCode }})"</strong>?
                        Thao tác này không thể hoàn tác.
                    </v-card-text>
                    <v-card-actions class="px-6 pb-4">
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" text class="rounded-lg font-weight-bold px-4" @click="dialogDelete = false">Hủy</v-btn>
                        <v-btn color="red darken-1" dark class="rounded-lg font-weight-bold px-4" depressed @click="cfmDeleteItem">Xóa</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>

<script>
// Nhập các component và dịch vụ xử lý dữ liệu
import createDialog from './Create';
import http from '@/components/services/http-common';
import ApiService from '@/components/services/ApiServices';
import * as moment from "moment/moment";

const ClearDeviceURL = "users/clear-device/";

export default {
    name: "User-index",
    components: {
        "create-dialog": createDialog
    },
    data() {
        return {
            // Tab hiện tại (0: Nhân viên, 1: Admin, 2: API & test, 3: Lịch sử)
            tab: 0,

            // Trạng thái tải và dialog
            isLoading: true,
            isLoadingLogs: false,
            dialogDelete: false,
            dialog: false,
            targetItem: null,

            // Dữ liệu danh sách tài khoản
            items: [],
            admins: [],
            services: [],
            logs: [],
            rowCount: 0,
            departments: [],

            // Tham số phân trang & sắp xếp
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
                pageSize: 10000
            },

            // Bộ lọc dữ liệu tìm kiếm
            filters: {
                employeeCode: null,
                employeeName: null,
                code: null,
                userName: null,
                departmentCode: null
            },

            // Cấu hình cột hiển thị cho bảng tài khoản
            headers: [
                { text: this.$t('view.user.action'), value: 'actions', sortable: false, width: 140, align: 'center' },
                { text: this.$t('view.user.employee_code'), value: 'employeeCode', width: 140 },
                { text: this.$t('view.user.employee_name'), value: 'employeeName', width: 200 },
                { text: 'Phòng ban', value: 'departmentName', width: 200 },
                { text: this.$t('view.user.user_code'), value: 'code', width: 140 },
                { text: this.$t('view.user.user_name'), align: 'start', sortable: false, value: 'userName', width: 180 },
                { text: this.$t('view.user.is_active'), value: 'isActive', width: 130, align: 'center' },
                { text: this.$t('view.user.permission'), value: 'userRoles', sortable: false },
                { text: 'Thiết bị', value: 'usedDevice', sortable: false, width: 110, align: 'center' }
            ],

            // Cấu hình cột hiển thị cho bảng lịch sử thao tác
            headerLogs: [
                { text: this.$t('view.user.action'), value: 'action', width: 160 },
                { text: this.$t('view.user.user_code'), value: 'code', width: 180 },
                { text: this.$t('view.user.updated_by'), value: 'updatedBy', width: 200 },
                { text: this.$t('view.user.updated_at'), value: 'updatedAt', width: 200 }
            ]
        };
    },
    computed: {
        // Gộp tham số phân trang và bộ lọc gửi lên server
        params() {
            return { ...this.tableParams, ...this.filters };
        },

        // Danh sách tài khoản thuộc tab đang được chọn
        currentTabItems() {
            if (this.tab === 1) return this.admins;
            if (this.tab === 2) return this.services;
            return this.items;
        },

        // Dữ liệu phục vụ xuất file Excel
        excelData() {
            const list = this.currentTabItems || [];
            return list.map(x => ({
                employeeCode: x.employeeCode || '',
                employeeName: x.employeeName || '',
                code: x.code || '',
                userName: x.userName || '',
                departmentName: x.departmentName || '',
                isActive: x.isActive ? 'Hoạt động' : 'Khóa',
                role: (x.userRoles || []).map(c => c.roleName).join(', ')
            }));
        },

        // Cấu hình cột cho file Excel
        excelColumns() {
            return [
                { label: 'Mã NS', field: 'employeeCode' },
                { label: 'Tên NS', field: 'employeeName' },
                { label: 'Mã người dùng', field: 'code' },
                { label: 'Tên đăng nhập', field: 'userName' },
                { label: 'Phòng ban', field: 'departmentName' },
                { label: 'Trạng thái', field: 'isActive' },
                { label: 'Phân quyền', field: 'role' }
            ];
        }
    },
    watch: {
        // Tự động tải lại khi đổi phân trang / sắp xếp
        tableParams: {
            handler() {
                this.fetchData();
            },
            deep: true
        },

        // Tự động tải lại khi người dùng thay đổi giá trị bộ lọc (có debounce)
        filters: {
            handler: _.debounce(function () {
                this.tableParams.page = 1;
                this.fetchData();
            }, 500),
            deep: true
        }
    },
    methods: {
        // Định dạng ngày giờ hiển thị
        formatDate(value, hasTime = false) {
            if (!value) return '';
            return hasTime
                ? moment(value).format("DD/MM/YYYY HH:mm:ss")
                : moment(value).format("DD/MM/YYYY");
        },

        // Xác định màu sắc chip hiển thị cho từng loại thao tác trong log
        getActionColor(action) {
            if (!action) return 'grey lighten-3';
            const act = action.toUpperCase();
            if (act.includes('CREATE') || act.includes('THÊM')) return 'green lighten-4 green--text text--darken-4';
            if (act.includes('UPDATE') || act.includes('SỬA')) return 'blue lighten-4 blue--text text--darken-4';
            if (act.includes('DELETE') || act.includes('XÓA')) return 'red lighten-4 red--text text--darken-4';
            return 'blue-grey lighten-4 blue-grey--text text--darken-4';
        },

        // Mở dialog tạo mới tài khoản
        openDialog() {
            if (this.$refs.createDialog) {
                this.$refs.createDialog.isUpdate = false;
                this.$refs.createDialog.item = null;
                this.$refs.createDialog.form = Object.assign({}, this.$refs.createDialog.defaultForm);
            }
            this.dialog = true;
        },

        // Đặt lại các giá trị lọc tìm kiếm
        resetFilters() {
            this.filters = {
                employeeCode: null,
                employeeName: null,
                code: null,
                userName: null,
                departmentCode: null
            };
        },

        // Lấy danh sách người dùng từ máy chủ
        fetchData() {
            this.isLoading = true;
            return http.get('users', {
                params: this.params
            }).then(res => {
                this.items = res.data.users || [];
                this.admins = res.data.admins || [];
                this.services = res.data.services || [];
                this.rowCount = res.data.rowCount || 0;
            }).catch(err => {
                console.error("Lỗi khi tải dữ liệu người dùng:", err);
            }).finally(() => {
                this.isLoading = false;
            });
        },

        // Lấy danh mục phòng ban để chọn trong bộ lọc
        fetchDepartment() {
            ApiService.fetchDepartment().then(res => {
                this.departments = res.data || [];
            }).catch(err => {
                console.error("Lỗi khi tải phòng ban:", err);
            });
        },

        // Lấy lịch sử thao tác người dùng
        fetchLogs() {
            this.isLoadingLogs = true;
            return http.get("users/fetch/log").then(res => {
                this.logs = res.data.logs || [];
            }).catch(err => {
                console.error("Lỗi khi tải lịch sử thao tác:", err);
            }).finally(() => {
                this.isLoadingLogs = false;
            });
        },

        // Mở dialog xác nhận xóa người dùng
        deleteItem(item) {
            this.targetItem = item;
            this.dialogDelete = true;
        },

        // Thực hiện xóa người dùng sau khi xác nhận
        cfmDeleteItem() {
            if (!this.targetItem) return;
            http.delete("users/" + this.targetItem.code).then(() => {
                this.fetchData();
                this.dialogDelete = false;
                this.targetItem = null;
            }).catch(err => {
                console.error("Lỗi khi xóa người dùng:", err);
            });
        },

        // Mở dialog cập nhật thông tin người dùng
        editItem(item) {
            if (this.$refs.createDialog) {
                this.$refs.createDialog.isUpdate = true;
                this.$refs.createDialog.item = item;
                this.$refs.createDialog.fetchUpdate(item.code);
                this.$refs.createDialog.dialog = true;
            }
            this.dialog = true;
        },

        // Reset thiết bị đã lưu cho tài khoản
        clearDevice(item) {
            return http.get(ClearDeviceURL + item.code).then(() => {
                this.fetchData();
            }).catch(err => {
                console.error("Lỗi khi reset thiết bị:", err);
            });
        }
    },
    mounted() {
        // Tải dữ liệu ban đầu khi mount component
        this.fetchDepartment();
        this.fetchData();
        this.fetchLogs();
    }
};
</script>

<style scoped>
/* Định dạng tiêu đề cột bảng dữ liệu */
.my-custom-table ::v-deep thead th {
    background-color: #F8F9FA !important; 
    height: 48px !important;
}

.my-custom-table ::v-deep thead th span {
    font-weight: 600 !important;
    color: #37474F !important;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
}

/* Định dạng thanh Tabs */
.custom-tabs ::v-deep .v-tab {
    text-transform: none !important;
    letter-spacing: normal !important;
}

/* Hiệu ứng hover dòng trong bảng */
.my-custom-table ::v-deep tbody tr:hover {
    background-color: #F1F8E9 !important;
}
</style>